import React, { useEffect } from 'react';
import { ContactOrganizerButton } from '../../components-redesign/ContactOrganizerButton';
import { FollowOrganizer } from '../../components/FollowOrganizer';
import { UseTrustSignalsContext } from '../../context';
import { Organizer } from '../../types';
import { OrganizerTrustSignals } from '../OrganizerTrustSignals';

interface OrganizerDetailsProps {
    organizer?: Organizer;
    totalEvents: number;
    userId: string;
    organizerFollowExperiment?: boolean;
}

export const OrganizerDetails: React.FunctionComponent<
    OrganizerDetailsProps
> = (props) => {
    const { followers, totalEvents, setTotalEvents, setFollowers } =
        UseTrustSignalsContext();
    const { organizer, totalEvents: hostedEvents, userId } = props;

    useEffect(() => {
        setTotalEvents(hostedEvents);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hostedEvents]);

    if (!organizer) {
        return null;
    }

    return (
        <div className="organizer-profile-header__container">
            <div className="organizer-profile-header__container--button-group">
                <FollowOrganizer
                    organizer={organizer}
                    userId={userId}
                    renderFollowCount={(followCount: string) => {
                        setFollowers(Number(followCount));
                        return <></>;
                    }}
                />
                <ContactOrganizerButton />
            </div>
            <OrganizerTrustSignals
                organizer={organizer}
                followCount={followers}
                totalEvents={totalEvents}
            />
        </div>
    );
};
